<template>
  <div>
    <div class="c-banner">
      <div class="img-box">
        <img src="../../../../assets/image/bg-list.png">
      </div>
      <div class="txt-box">
        <div class="wrap-s">
          <div class="tit">人事招聘</div>
        </div>
      </div>
    </div>

    <div class="inner-page bg-2">
      <div class="sticky-nav">
        <div class="sticky">
          <div class="block">
            <div @click="navClick(index)" v-for="(x, index) in list" :key="index" class="box"
              :class="{ 'active': selectIndex == index }">

              <div class="tit">
                {{ x.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <router-view></router-view>
      </div>
    </div>

    <!-- <div class="de-main clearfix">
      <div class="de-list fl">
        <div class="big-title">
          人事招聘
        </div>
        <div @click="navClick(index)" v-for="(x, index) in list" :key="index" class="list-item"
          :class="{ 'list-item-active': selectIndex == index }">
          {{ x.title }}
        </div>
      </div>
      <div class="de-box fl" v-if="showList">
        <div class="top-nav clearfix">
          <div class="title fl">{{ hostTitle }}</div>
          <div class="place fr">人事招聘</div>
        </div>
        <div>
          <router-view></router-view>
        </div>
      </div>

    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
          {
            title: "博士后引进招聘",
            path: "/bshyj?column_id=761227058341044224",
          },
          {
            title: "高层次人才招聘",
            path: "/gccrc?column_id=761227158329057280",
          },
          {
            title: "管理人员招聘",
            path: "/glry?column_id=761227235487473664",
          },
          {
            title: "科研助理招聘",
            path: "/kyzlzp?column_id=761227514496770048",
          },
        ],
      selectIndex: 0,
      showList: true,
      navObj: {},
      hostStr: "",
      hostTitle: "",
      newList: [],
      newInfo: {}
    }
  },
  created() {
    if(this.$route.query.index){
      this.selectIndex = this.$route.query.index
    }else{
      this.selectIndex = 0
    }
    this.navClick(this.selectIndex)
  },
  methods: {
    
    navClick(index) {
      this.selectIndex = index
      this.$router.push({ path: this.list[this.selectIndex].path });
    },
    shoDetial() {
      this.showList = false
    },
    getInfoList() {
      let self = this
      this.$common.noLoginCallUrl("/api/cp-cms/site/info/getInfoPage",
        {
          column_id: this.column_id,
          pageNo: "1",
          pageCount: "5"
        },
        function (res) {
          if (res.code == "000000") {
            self.newList = res.data.data
          } else {
            self.$message.warning(res.msg)
          }
        })
    },
    getInfo(id) {
      let self = this
      this.$common.noLoginCallUrl("/api/cp-cms/site/info/getInfo",
        {
          article_id: id,
        },
        function (res) {
          if (res.code == "000000") {
            self.newInfo = res.data
          } else {
            self.$message.warning(res.msg)
          }
        })
    }
  },
  watch: { // 监听，当路由发生变化的时候执行
    $route(to, from) {
     
      if(this.$route.query.index){
        this.selectIndex = this.$route.query.index
      }
      this.column_id = this.$route.query.column_id
      
    },
  }
};
</script>

<style lang="less" scoped>
.c-banner {
  position: relative;
  z-index: 1;
  margin-top: -50px;
}

.c-banner:before {
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../../../../assets/image/banner-bg.png");
  z-index: 2;
}

.c-banner .img-box {
  position: relative;
  z-index: 1;
}

.c-banner .img-box img {
  display: block;
  width: 100%;
  height: 20vw;
  object-fit: cover;
}

.c-banner .txt-box {
  position: absolute;
  top: 5vw;
  left: 0;
  width: 100%;
  z-index: 3;
}

.c-banner .wrap-s {
  width: 90%;
  max-width: 1680px;
  margin: 0 auto;
  position: relative;
  z-index: 3;
}

.c-banner .tit {
  font-size: 80px;
  color: #fff;
  font-family: 'HarmonyOS_Sans_SC_Bold';
  text-align: right;
}



.inner-page {
  position: relative;
  z-index: 2;
  margin-top: -15vw;
  padding-top: 15vw;
}

.inner-page:before {
  content: '';
  width: 100%;
  height: 35vw;
  background: url("../../../../assets/image/inner-bg.png") center top no-repeat;
  background-size: 100% auto;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: -1;
}

.inner-page:after {
  content: '';
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -2;
  pointer-events: none;
}

.inner-page.bg-1 {
  min-height: 90vw;
}

.inner-page.bg-1:after {
  height: 55vw;
  // background: url("../2024images/culture/img-5.jpg") center bottom no-repeat;
  background-size: 100% auto;
}

.inner-page.bg-2 {
  min-height: 30vw;
}

.inner-page.bg-2:after {
  height: 37vw;
  // background: url("../2024images/about/img-1.jpg") center bottom no-repeat;
  background-size: 100% auto;
}

.inner-page.bg-3 {
  min-height: 60.5vw;
}

.inner-page.bg-3:after {
  height: 25.5vw;
  // background: url("../2024images/about/img-4.jpg") center bottom no-repeat;
  background-size: 100% auto;
}

.inner-page .sticky-nav {
  position: absolute;
  top: 12vw;
  bottom: 0;
  left: 0;
  z-index: 4;
}

.inner-page .sticky-nav .sticky {
  position: sticky;
  top: 0;
  height: 100vh;
  max-height: 100%;
  // background: url("../2024images/x-3.png") center center no-repeat;
  background-size: 100% 100%;
  padding: 48px;
  display: flex;
  align-items: center;
}

.inner-page .sticky-nav .sticky:before {
  content: '';
  width: 1px;
  position: absolute;
  top: 0;
  left: 48px;
  top: 24px;
  bottom: 24px;
  background-color: #e5e5e5;
  z-index: 1;
  display: none;
}

.inner-page .sticky-nav .block {
  width: 100%;
  border-left: 1px solid #e5e5e5;
}

.inner-page .sticky-nav .box {
  margin-top: 24px;
  position: relative;
  z-index: 2;
}

.inner-page .sticky-nav .box:nth-of-type(1) {
  margin-top: 0;
}

.inner-page .sticky-nav .box .tit {
  position: relative;
  display: inline-block;
  padding: 0 80px 0 40px;
}

.inner-page .sticky-nav .box .tit:before {
  content: '';
  width: 11px;
  height: 11px;
  border-radius: 50%;
  border: 5px solid rgba(140, 28, 64, 0.2);
  background-color: #8c1c40;
  background-clip: content-box;
  position: absolute;
  top: 50%;
  left: -11px;
  margin-top: -11px;
  opacity: 0;
  transition: opacity .3s ease;
}

.inner-page .sticky-nav .box .tit {
  display: block;
  font-size: 18px;
  color: #333333;
  transition: color .3s ease;
}

@media (any-hover: hover) {
  .inner-page .sticky-nav .box .tit:hover {
    color: #8c1c40;
  }
}

.inner-page .sticky-nav .box .tit i {
  width: 14px;
  height: 8px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  // background-image: url("../2024images/icon-2.svg");
  position: absolute;
  right: 24px;
  top: 50%;
  margin-top: -4px;
  cursor: pointer;
}



.inner-page .sticky-nav .box.active .tit:before {
  opacity: 1;
}

.main{
  padding: 0 120px 50px 350px;
}



@media screen and (max-width: 1025px) {
  .c-banner .img-box img {
    height: 30vh;
  }

  .c-banner .txt-box {
    top: 10vh;
  }
  .c-banner .tit{
    font-size: 36px;
  }
  .main{
    padding: 10px 20px;
  }
 
  .inner-page .sticky-nav{
    position: unset;
    // top: unset;
    // left: unset;
    
    .sticky{
      position: unset;
      padding: 0;
      height: unset;
      max-height: unset;
      margin: 0 10px;
      .block{
        display: flex;
        border-left: unset;
        flex-wrap: wrap;
        .box{
          margin-top: 0;
          width: 48%;
          height: 36px;
          line-height: 36px;
          background-color: #dddddd;
          margin: 2px;
          flex-grow: 1;
          .tit{
            text-align: center;
            text-wrap: nowrap;
            padding: 0;
          }
          &.active{
            .tit{
              color: #fff;
            }
            background-color: #8c1c40;
          }
        }
      }


    }
  }


  .inner-page .sticky-nav .box .tit:before{
    content: none;

  }
}

</style>